<template>
  <div>
    <yd-dialog :visible="dialogVisible" width="60%" :before-close="handleClose">
      <div slot="title">操作日志</div>
      <div>
        <LogInfo :visible="dialogVisible" :flightPlanId="linkId" :type="13" />
      </div>
      <div slot="footer">
        <el-button @click="handleClose">关 闭</el-button>
      </div>
    </yd-dialog>
  </div>
</template>

<script>
  import LogInfo from '@/components/logInfo/list.vue'

  export default {
    components: {
      LogInfo
    },
    data() {
      return {
        dialogVisible: false,
        linkId: ''
      }
    },
    methods: {
      init(id) {
        console.log(id)
        this.dialogVisible = true
        this.linkId = id
      },
      handleClose() {
        this.dialogVisible = false
      }
    }
  }
</script>

<style lang="scss" scoped></style>
